import flatpickr from 'flatpickr' // flatpickr
import 'flatpickr/dist/l10n/ja' // flatpickr日本語化

import { Autoplay, Controller, EffectFade, Parallax, Navigation, Pagination, Swiper, FreeMode } from 'swiper'
// import { SwiperSlide } from 'swiper/react'
Swiper.use([Autoplay, Controller, EffectFade, Parallax, Navigation, Pagination, FreeMode]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

//  ##      ##  #####  #####  ##  ##
//  ##      ##  ##     ##     ## ##
//  ##  ##  ##  #####  #####  ####
//  ##  ##  ##  ##     ##     ## ##
//   ###  ###   #####  #####  ##  ##

if (document.getElementById('eventWeek')) {
  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars

  const slideItem = document.getElementById('eventWeek')

  const sliderName = 'eventWeek'
  const eventWeekSwiper = new Swiper(slideItem, {
    // init: false, // 自動で初期化しない（eventWeekSwiper.init()で初期化）
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    preloadImages: false, // スライド内の画像を読み終えてから開始
    slidesPerView: 3, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
    slidesPerGroup: 3, // 一度のスライド数
    // spaceBetween: 10, //スライド同士の間隔を空ける

    navigation: {
      nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    },

    breakpoints: {
      // 指定px以上でオプション切り替え
      769: {
        slidesPerView: 7, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
        slidesPerGroup: 7, // 一度のスライド数
      },
    },
  })
}

//  ####      ###    ######  #####
//  ##  ##   ## ##     ##    ##
//  ##  ##  ##   ##    ##    #####
//  ##  ##  #######    ##    ##
//  ####    ##   ##    ##    #####
/*
flatpickrによるデートピッカー
本コード冒頭のインポートと_js.scssのCSSインポートを有効化して使用

例：
<input type="text" name="date1" class="js-date">
<input type="text" name="date2" class="js-date">
*/
window.eventCal = function () {
  if (!document.getElementsByClassName('js-date')[0]) {
    return
  }

  const datepicker = flatpickr('.js-date', {
    // 指定クラスにデートピッカーを付ける
    minDate: new Date().fp_incr(0), // 最短設定日 n日後から
    maxDate: new Date().fp_incr(60), // 最長設定日 n日後まで
    // mode: 'range', // 範囲で指定させる
    locale: 'ja',
    altFormat: 'Y.m.d',
    dateFormat: 'Y.m.d',
    disableMobile: true, // SP時にブラウザ標準の日付UIに切り替えない
    // altFormat: 'Y/m/d H:i',
    // dateFormat: 'Y/m/d H:i',
    // enableTime: true, // 時間指定可能にする
    // time_24hr: false, // 24h/AMPM形式
    disable: [
      // 選択禁止する日付　trueを返すと禁止
      // function (date) {
      //   // 指定番号の曜日と合致したら禁止　0:日曜～6:土曜
      //   if (date.getDay() === 0) {
      //     return true
      //   }
      // },
    ],
    onChange: function (selectedDates, dateStr, instance) {
      window.applyAjax('./?date=' + dateStr, 'GET', null, '#eventSc', '#eventSc', false, 'rep', false)
    },
  })
}
window.eventCal() // イベントカレンダーを呼び出す
